import { Box, Container } from "@mui/material"
import folderCover from "../../assets/imgs/icons/folder-cover.png"
import { BookPopup } from "../modals/BookPopup";
import { useState } from "react";
export const DocuCharleeHero = () => {

  const [isOpenBook, setIsOpenBook] = useState(false);

  const handleCloseBook = () => {
    setIsOpenBook(false)
  }

  const handleOpenBook = () => {
    setIsOpenBook(true)
  }

  return (
    <Box className="w-full pt-24">
      <Container maxWidth="lg">
        <Box className="w-full text-center px-6 pt-16">
          <Box className="w-full" paddingBottom={3} display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <img className="docuChalee-logo" src={folderCover} alt="DocuCharlee product logo" width={48} height={48} />
            <h5 className="text-[29px] leading-[40px] font-medium mx-2">
              <span className="docuChalee-logoTxt">DocuCharlee</span>
            </h5>
          </Box>
          <h1 className="overflow-y-hidden hidden md:block text-[65px] leading-[71.5px] font-medium tracking-normal">
            <span className="docuChalee-head inline-block">
              AI Claims Document <br />Summarization Software
            </span>
          </h1>
          <h1 className="overflow-y-hidden block md:hidden text-[36px] leading-[39.5px] font-medium tracking-normal">
            <span className="docuChalee-head inline-block">
              AI Claims Document Summarization Software
            </span>
          </h1>
          <p className="docuChalee-txt text-[16px] py-5">
            <span className="docuChalee-txt-inner">
              DocuCharlee uses AI and natural language processing to create clear, concise claim summaries, pulling<br />
              out key details to help insurers save time and make better decisions faster.
            </span>
          </p>
          <button onClick={() => handleOpenBook()} className="docuChalee-book mt-6 w-full md:w-auto rounded-full text-[18px] leading-[24px] bg-transparent border py-3 px-10 border-[#021744] text-[#021744] hover:text-white hover:bg-[#021744]">
            Book a demo
          </button>
        </Box>
      </Container>
      <BookPopup open={isOpenBook} handleClose={handleCloseBook} />
    </Box>
  )
}